import { render, staticRenderFns } from "./PageLink.vue?vue&type=template&id=d0439d98&scoped=true"
import script from "./PageLink.vue?vue&type=script&lang=js"
export * from "./PageLink.vue?vue&type=script&lang=js"
import style0 from "./PageLink.vue?vue&type=style&index=0&id=d0439d98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0439d98",
  null
  
)

export default component.exports